import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Probleme" className="border-y border-grape/10 bg-white/70" data-id="element-114" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px'
    }} data-id="element-115" data-mp="26xmt34jwpsfl">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-116" data-mp="2bwhb44a1vcyn">
          ❓ Erkennst du dich in einer dieser Situationen wieder?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-117" data-mp="21z32gqudbsgw">
          Du liebst K-Dramen und K-Pop, möchtest verstehen, was sie wirklich sagen, aber jedes Mal,
          wenn du versuchst Koreanisch zu lernen, verlierst du dich zwischen den Symbolen, Apps und
          zufälligen Vokabellisten, die zu nichts führen.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-118" data-mp="3ibi5w6nc9p3n">
          Das ist nicht mangelndes Talent. Das ist nicht mangelnde Anstrengung. Das ist ein Mangel
          an visuellem System.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-119" data-mp="1u1u2135vz0lm">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" data-id="element-120" data-mp="27sqn88xhgfin" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-121" data-mp="1p292ormt0q8d">
                {p.emoji}
              </span>
              <div data-id="element-122" data-mp="30gcq1eyvzg4g">
                <h3 className="text-sm font-bold text-plum" data-id="element-123" data-mp="30ftceag9rdw8">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-124" data-mp="2vhrptfjmwwg0">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-125" data-mp="1y488d82hs1uf">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-126" data-mp="1y2x0aw20k7xi">
            ✨ Wenn du zu einer dieser Situationen JA gesagt hast, haben wir die Lösung.
          </p>
          <p className="mt-3 text-lg font-semibold text-blush-deep" data-id="element-127" data-mp="2756crrguebdj">
            Tag 60 könnte sich komplett anders anhören. 🌸
          </p>
        </div>
      </div>
    </section>;
}